// removed by extract-text-webpack-plugin
module.exports = {"avatar":"avatar--e6834"};